import { IconCheck, IconX, IconAlertTriangle, IconInfoCircle } from '@tabler/icons-react';

/**
 * Get color for status badge
 */
export const getStatusColor = (status: string): string => {
  switch (status.toLowerCase()) {
    case 'healthy':
    case 'running':
      return 'green';
    case 'degraded':
      return 'yellow';
    case 'unhealthy':
    case 'stopped':
      return 'red';
    default:
      return 'gray';
  }
};

/**
 * Get icon for status
 */
export const getStatusIcon = (status: string) => {
  switch (status.toLowerCase()) {
    case 'healthy':
    case 'running':
      return <IconCheck size={16} />;
    case 'degraded':
      return <IconAlertTriangle size={16} />;
    case 'unhealthy':
    case 'stopped':
      return <IconX size={16} />;
    default:
      return <IconInfoCircle size={16} />;
  }
};

/**
 * Format uptime string (e.g., "00:05:23.4567890" -> "5m 23s")
 */
export const formatUptime = (uptime: string): string => {
  const parts = uptime.split(':');
  if (parts.length < 3) return uptime;

  const hours = parseInt(parts[0], 10);
  const minutes = parseInt(parts[1], 10);
  const seconds = parseFloat(parts[2]);

  const days = Math.floor(hours / 24);
  const remainingHours = hours % 24;

  if (days > 0) {
    return `${days}d ${remainingHours}h ${minutes}m`;
  }
  if (remainingHours > 0) {
    return `${remainingHours}h ${minutes}m`;
  }
  return `${minutes}m ${Math.floor(seconds)}s`;
};
